module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center",
    attrs: {
      "id": "page_ii"
    }
  }, [_c('a', {
    attrs: {
      "id": "lev01"
    }
  }), _c('strong', [_vm._v("STITCHING GUIDE")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "borderb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablehead"
  }, [_c('strong', [_vm._v("Fabric")])])]), _vm._v(" "), _c('td', {
    staticClass: "borderb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablehead"
  }, [_c('strong', [_vm._v("Threads/Yarn")])])]), _vm._v(" "), _c('td', {
    staticClass: "borderb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablehead"
  }, [_c('strong', [_vm._v("Needles")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "borderb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Plush, Velvets, and Wools")])]), _vm._v(" "), _c('td', {
    staticClass: "borderb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Silk Ribbon, Silk Buttonhole Twist, Embroidery Floss")])]), _vm._v(" "), _c('td', {
    staticClass: "borderb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Crewel No. 6, 7, 8 or Chenille No. 18-24")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "borderb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Cottons, Polyesters, Linens, and Shantungs")])]), _vm._v(" "), _c('td', {
    staticClass: "borderb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Embroidery Floss, Persian Wool, Perle Cotton, Tapestry Wool, Marlett, Metallics")])]), _vm._v(" "), _c('td', {
    staticClass: "borderb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Crewel No. 4, 5, 6, 7 or Tapestry No. 20 or 22")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "borderb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Moiré, Taffeta, Shot Cloths, and Satins")])]), _vm._v(" "), _c('td', {
    staticClass: "borderb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Embroidery Floss, Brazilian Embroidery Thread, Perle Cotton, Marlett, Metallics, Natesh®")])]), _vm._v(" "), _c('td', {
    staticClass: "borderb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Crewel No. 4, 5, 6, 7, 8")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "borderb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Lightweight Silks, Organzas, Batistes")])]), _vm._v(" "), _c('td', {
    staticClass: "borderb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Embroidery Floss, Brazilian Embroidery Thread, Cotton á Broder, Filo-Floss, Linen Thread, Marlett, Metallics, Natesh, Perle Cotton, Silk Buttonhole Twist")])]), _vm._v(" "), _c('td', {
    staticClass: "borderb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Crewel No. 6, 7, 8")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "borderb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Knits, Loosely Woven Fabrics")])]), _vm._v(" "), _c('td', {
    staticClass: "borderb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Persian Wool, Crewel Yarns")])]), _vm._v(" "), _c('td', {
    staticClass: "borderb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Chenille No. 18 or 20 or Tapestry No. 13, 16, or 18")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Canvas for Needlepoint or Cross Stitch")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Embroidery Floss, Brazilian Embroidery Thread, Cotton á Broder, Filo-Floss, Linen Thread, Marlett, Metallics, Natesh, Perle Cotton, Silk Buttonhole Twist, Silk Ribbon, Silk Sewing Thread, Soi d’ Algere, Stranded Embroidery Floss, Tapestry Wool, Ver a Soi")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Tapestry No. 24 or 26 or Chenille No. 18-24")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f497f10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9781607053590_01_fmt.vue
// module id = 60
// module chunks = 0